//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const AllowIgnoreApiCacheControl: FeatureFlag = {"Id":"AllowIgnoreApiCacheControl","Label":"Allow ignoring API Cache-Control response header","Impact":"Allow users to configurate API to ignore the Cache-Control response header","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
